export function returnPricingCopyFor({ key, fee }) {
  if (key === 'canada') {
    return 'Return within 45 days of purchase. Free of charge.'
  }

  if (key === 'zigzag') {
    return `Return within 45 days of ship date for a fee of ${fee}.`
  }

  return 'Return within 45 days of purchase.'
}

export function returnDutiesAndTaxesCopyFor(shippingCountry, dutiesAndTaxesRefunded) {
  if (shippingCountry === 'CA') {
    return 'Taxes refundable upon return of product'
  }

  return dutiesAndTaxesRefunded
    ? 'Duties & taxes refundable upon return of product'
    : 'Duties & taxes are non-refundable'
}
